import React from 'react';
import { Menu, Button } from '@material-ui/core';
import { Icon } from 'gd-react';
import './ModifierSourceSelector.scss';

class ModifierSourceSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClick(e) {
        this.setState({
            anchorEl: e.currentTarget
        });
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    handleSelectSource = (source) => {
        const { modifierKey, onSourceSelect } = this.props;
        onSourceSelect(modifierKey, source);
        this.handleClose();
    }

    render() {
        const { anchorEl } = this.state;
        const { modifierName, currentSource, sourceOptions, children } = this.props;

        // Use provided sourceOptions if available, otherwise fall back to default options
        const options = sourceOptions || [
            {
                key: 'platform',
                title: 'Platform Default',
                description: currentSource === 'platform' 
                    ? 'Currently using system default (cannot be edited)'
                    : 'Switch to system default (cannot be edited)',
                icon: 'FiGlobe',
                color: '#1976d2'
            },
            {
                key: 'org',
                title: 'Organization Global',
                description: currentSource === 'org'
                    ? 'Currently using organization settings (can be edited for all assets)'
                    : 'Switch to organization settings (can be edited for all assets)',
                icon: 'FiUsers',
                color: '#f57c00'
            },
            {
                key: 'asset',
                title: 'Asset Specific',
                description: currentSource === 'asset'
                    ? 'Currently using asset-specific settings (can be edited)'
                    : 'Switch to asset-specific settings (can be edited)',
                icon: 'FiSettings',
                color: '#388e3c'
            }
        ];

        return (
            <div className="modifier-source-selector">
                <div onClick={this.handleClick}>
                    {children}
                </div>
                <Menu
                    id="modifier-source-selector"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    disableEnforceFocus
                    style={{ zIndex: 9999 }}
                >
                    <div className="source-selector-content" style={{ background: 'white', borderRadius: '8px', padding: '0 16px', minWidth: '320px' }}>
                        <div className="selector-header" style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #e0e0e0' }}>
                            <h4 style={{ margin: '0 0 2px 0', fontSize: '16px', fontWeight: 600, color: '#333' }}>
                                {currentSource === 'platform' ? 'Switch from Platform Default' : 'Change Modifier Source'}
                            </h4>
                            <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                                {currentSource === 'platform' 
                                    ? `Currently using system default. Choose where "${modifierName}" should be sourced from.`
                                    : `Currently using ${currentSource === 'asset' ? 'asset-specific' : 'organization'} settings. Select a different source.`
                                }
                            </p>
                        </div>
                        
                        <div className="source-options">
                            {options.map((option) => {
                                const isCurrent = currentSource === option.key;
                                return (
                                    <div 
                                        key={option.key}
                                        className={`source-option ${isCurrent ? 'current' : ''}`}
                                        onClick={() => this.handleSelectSource(option.key)}
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            padding: '12px', 
                                            marginBottom: '8px', 
                                            borderRadius: '8px', 
                                            cursor: 'pointer', 
                                            transition: 'all 0.2s ease',
                                            border: isCurrent ? '2px solid #007bff' : '2px solid transparent',
                                            background: isCurrent ? '#f0f8ff' : 'white'
                                        }}
                                    >
                                        <div className="source-icon" style={{ 
                                            marginRight: '12px', 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center', 
                                            width: '40px', 
                                            height: '40px', 
                                            borderRadius: '8px', 
                                            background: '#f8f9fa',
                                            flexShrink: 0
                                        }}>
                                            <Icon 
                                                icon={option.icon} 
                                                size={20} 
                                                color={option.color}
                                            />
                                        </div>
                                        <div className="source-content" style={{ flex: 1 }}>
                                            <div className="source-title" style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                fontWeight: 600, 
                                                fontSize: '14px', 
                                                color: '#333', 
                                                marginBottom: '2px' 
                                            }}>
                                                {option.title}
                                                {isCurrent && <span className="current-badge" style={{ 
                                                    marginLeft: '8px', 
                                                    padding: '2px 6px', 
                                                    backgroundColor: '#28a745', 
                                                    color: 'white', 
                                                    borderRadius: '4px', 
                                                    fontSize: '10px', 
                                                    fontWeight: 500 
                                                }}>Current</span>}
                                                {!isCurrent && option.action === 'create' && <span className="create-badge" style={{ 
                                                    marginLeft: '8px', 
                                                    padding: '2px 6px', 
                                                    backgroundColor: '#ff9800', 
                                                    color: 'white', 
                                                    borderRadius: '4px', 
                                                    fontSize: '10px', 
                                                    fontWeight: 500 
                                                }}>Create</span>}
                                            </div>
                                            <p style={{ margin: 0, fontSize: '12px', color: '#666', lineHeight: 1.4 }}>{option.description}</p>
                                        </div>
                                        {isCurrent && (
                                            <div className="current-indicator" style={{ 
                                                marginLeft: '8px', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center', 
                                                width: '24px', 
                                                height: '24px', 
                                                borderRadius: '50%', 
                                                backgroundColor: '#28a745',
                                                flexShrink: 0
                                            }}>
                                                <Icon icon="FiCheck" size={16} color="white" />
                                            </div>
                                        )}
                                        {!isCurrent && (
                                            <div className="switch-indicator" style={{ 
                                                marginLeft: '8px', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center', 
                                                width: '24px', 
                                                height: '24px', 
                                                borderRadius: '50%', 
                                                backgroundColor: option.action === 'create' ? '#ff9800' : '#f0f0f0',
                                                flexShrink: 0
                                            }}>
                                                <Icon 
                                                    icon={option.action === 'create' ? 'FiPlus' : 'FiArrowRight'} 
                                                    size={14} 
                                                    color={option.action === 'create' ? 'white' : '#666'} 
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Menu>
            </div>
        );
    }
}

export default ModifierSourceSelector;
